import { Injectable } from '@angular/core';

import { HttpParams, HttpClient } from '@angular/common/http';
import { BBResponseContainer } from '../carrier/response-container';
import { tap, timeout } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { QCReportProcessingRequest } from '../qualityreport-list/models/QCReportProcessingRequest';

@Injectable({
  providedIn: 'root'
})
export class QcreportDetailService {

  constructor(private http: HttpClient) { }

  getQCReportService(qcReportId: string) {
    let url = environment.BB_QC_REPORT_MANAGEMENT_URL + 'qcreport/detail';
    let requestParam = new HttpParams().set('qcReportId', qcReportId);

    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
      error.url = url;
    }));
  }

  updateQcReportDetail(qcReportProcessingRequest: QCReportProcessingRequest) {
    let url = environment.BB_QC_REPORT_MANAGEMENT_URL + 'qcreport';
    return this.http.put<BBResponseContainer>(url, qcReportProcessingRequest).pipe(timeout(environment.defaultTimeout), tap(event => { }, error => {
      error.url = url;
    }));
  }

  getReactionSetInformationForPlate(barcode: string){
    let url = environment.BB_SEQUENCING_SERVICE_URL + 'reactionset/plateview';
    let requestParam = new HttpParams().set('plateName', barcode);

    const options = url ? { params: requestParam } : {};
    return this.http.get<BBResponseContainer>(url, options).pipe(tap(event => { }, error => {
      error.url = url;
    }));
  }

}
